import React, { memo, VFC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import {
  Theme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid
} from '@material-ui/core';
// types
import type { estimateType } from '../../types/deliveryContract';
import { Spacer } from '../atoms';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      width: '100%',
      padding: 15,
      display: 'flex',
      justifyContent: 'flex-start'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: 15
    },
    head: {
      backgroundColor: '#0099CC'
    },
    body: {
      backgroundColor: '#F5F5F5'
    },
    headText: {
      color: '#FFFFFF',
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: 1
    },
    bodyText: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 1
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 32,
      width: '50%'
    },
    button: {
      color: '#758283',
      backgroundColor: '#F5F5F5'
    }
  })
);

type Props = {
  data: estimateType[];
  copyArr: estimateType[];
  onChange: (i: number, value: number) => void;
  removeFn: (id: number) => void;
  disabled: boolean;
  createFn: () => void;
};

const EstimateList: VFC<Props> = props => {
  const { data, onChange, copyArr, removeFn, disabled, createFn } = props;
  const classes = useStyles();

  return (
    <>
      <Grid item className={classes.tableContainer}>
        <TableContainer>
          <Table>
            <TableHead className={classes.head}>
              <TableRow>
                <TableCell className={classes.headText} align={'center'}>
                  見積番号
                </TableCell>
                <TableCell className={classes.headText} align={'center'}>
                  合計金額
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody className={classes.body}>
              {copyArr.length > 0 &&
                copyArr.map((estimate, i) => (
                  <TableRow style={{ maxWidth: '50%' }} key={estimate.id}>
                    <TableCell align={'center'}>
                      <select
                        value={estimate.id}
                        onChange={event => {
                          onChange(i, Number(event.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {data.map(d => (
                          <option key={d.id} value={d.id}>
                            {d.code}
                          </option>
                        ))}
                      </select>
                    </TableCell>
                    <TableCell className={classes.bodyText} align={'center'}>
                      {estimate.billing_total !== null
                        ? `${estimate.billing_total.toLocaleString()}円`
                        : '0円'}
                    </TableCell>
                    <TableCell className={classes.bodyText} align={'center'}>
                      <Button
                        className={classes.button}
                        variant='contained'
                        onClick={() => removeFn(estimate.id)}
                      >
                        削除
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Spacer size={'small'} />
      <div className={classes.buttonContainer}>
        <Button
          variant='contained'
          disabled={disabled}
          className={classes.button}
          onClick={createFn}
        >
          追加
        </Button>
      </div>
    </>
  );
};

export default memo(EstimateList);
